<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style lang="stylus" type="text/stylus"  rel="stylesheet/stylus">
@import './assets/css/public.styl'
body
  margin 0
  padding 0

#app
  font-family "Helvetica Neue", Helvetica, "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  color #fff;
  background url("./assets/img/loginbg.png") no-repeat;
  background-size 100% 100%;
  height 100%;
  width 100%;
  overflow-y hidden;
  min-height 720px;
  min-width 1080px;

</style>



// WEBPACK FOOTER //
// src/App.vue